import axios from "../javascript/custom-axios";

export default {
  getQRUsers(usernames) {
    return axios.get('admin/get-qr-users', {
      params: { Usernames: usernames }
    });
  },
  
  createQR(usernames) {
    return axios.post('admin/create-qr', {
      Users: usernames
    }, {
      responseType: 'blob'
    });
  }
};

